import {Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";
import {SUPER_ADMIN} from "../../../helpers/constants";
import NameInputRow from "../NameInputRow";
import PromoterCategorySelectRow from "../PromoterCategory/PromoterCategorySelectRow";
import CompanySelectRow from "../CompanySelectRow";
import ModalButtonsRow from "../ModalButtonsRow";
import CheckBoxRow from "../CheckBoxRow";

const PromoterSectionModal = props => {

    const companiesSelect = props.authority === SUPER_ADMIN
        ? <CompanySelectRow
            lang={props.lang}
            onCompanyChange={props.onInputChange}
            companyId={props.newSection.companyId}
            companies={props.companies}
            validator={props.validator}
        />
        : null;

    const categorySelect = (
        <PromoterCategorySelectRow
            lang={props.lang}
            companyIdFilter={props.newSection.companyId}
            onCategoryChange={props.onInputChange}
            categoryId={props.newSection.categoryId}
            categories={props.categories}
            validator={props.validator}
            required
        />
    )

    const nameInputRow = (
        <NameInputRow
            lang={props.lang}
            defaultValue={props.newSection.name}
            onNameChange={props.onInputChange}
            validator={props.validator}
            required
            autoFocus
        />
    )

    const showPriceTagCheckbox = (
        <CheckBoxRow
            id="showPriceTag"
            name="showPriceTag"
            label={I18n[props.lang].modal.showPriceTag}
            checked={props.newSection.showPriceTag}
            onChange={props.onInputChange}
        />
    );

    const buttons = (
        <ModalButtonsRow
            lang={props.lang}
            onCancelClick={props.toggle}
            isSaveDisable={props.isSaveDisable}
        />
    )

    return (
        <Modal
            isOpen={props.isModal}
            toggle={props.toggle}
            centered
            autoFocus={false}
        >
            <ModalHeader toggle={props.toggle}>
                {I18n[props.lang].modal.addOrEditSection}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={props.handleSubmit}>
                    {companiesSelect}
                    {categorySelect}
                    {nameInputRow}
                    {showPriceTagCheckbox}
                    {buttons}
                </Form>
            </ModalBody>
        </Modal>
    );
}

export default PromoterSectionModal;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSection/PromoterSectionModal.js